import { AaGetcaptchaResp } from 'app/bff/models/aa/aaGetcaptcha';
import { AaCaptchaVerifyReq } from 'app/bff/models/aa/aaCaptchaVerify';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { Captcha, LoginInfo, MbSigninReq, MbSigninResp } from 'app/bff/models/mb/mbSignin';
import { MbSignoutReq } from 'app/bff/models/mb/mbSignout';
import { ROUTES } from 'app/core/router/paths';
import { MobileLoginProcessStepCodesEnum } from 'app/common/components/Modals/MemberLoginModal/types';
import { LoginActions, MEMBER_LOGIN__SET_MOBILE_LOGIN_CURRENT_STEP, MEMBER_LOGIN__FETCH_CAPTCHA, MEMBER_LOGIN__FETCH_CAPTCHA_DONE, MEMBER_LOGIN__FETCH_MEMBER_PROFILE_BY_MOBILE_LOGIN, MEMBER_LOGIN__BY_PASS_PHRASE_LOGIN, MEMBER_LOGIN__SAVE_MOBILE_LOGIN_DATA, MEMBER_LOGIN__SEND_OTP_DONE, MEMBER_LOGIN__RESEND_OTP, MEMBER_LOGIN__RESEND_OTP_DONE, MEMBER_LOGIN__LOGIN_BY_OTP, MEMBER_LOGIN__SET_LOGIN_REDIRECT_URL, MEMBER_LOGIN__RESET_LOGIN_CACHE, MEMBER_LOGIN__SEND_LOGOUT, MEMBER_LOGIN__CHECK_LAST_TIME_PASSWORD_DATE } from './types';
import { MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';

/**
 * @description 設置手機驗證登入當前步驟 (Action)
 * @param step 當前步驟
 */
export const setMobileLoginCurrentStepAction = (step: MobileLoginProcessStepCodesEnum): LoginActions => ({
  type: MEMBER_LOGIN__SET_MOBILE_LOGIN_CURRENT_STEP,
  payload: { step }
});

/**
 * @description 取得圖形驗證碼 (Action)
 */
export const fetchCaptchaAction = (): LoginActions => ({
  type: MEMBER_LOGIN__FETCH_CAPTCHA
});

/**
 * @description 取得圖形驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const fetchCaptchaDoneAction = (response: AaGetcaptchaResp): LoginActions => ({
  type: MEMBER_LOGIN__FETCH_CAPTCHA_DONE,
  payload: { response }
});

/**
 * @description 取得會員資料 (手機驗證登入) (Action)
 * @param fetchMemberProfileArgs 取得會員資料，請求所需的參數
 * @param checkCaptchaArgs 驗證圖形驗證碼，請求所需的參數
 * @param sendOTPArgs 發送 OTP 驗證碼，請求所需的參數
 * @param data 表單資料
 */
export const loginByMobileLoginAction = (checkCaptchaArgs: AaCaptchaVerifyReq, data: LoginInfo): LoginActions => ({
  type: MEMBER_LOGIN__FETCH_MEMBER_PROFILE_BY_MOBILE_LOGIN,
  payload: { checkCaptchaArgs, data }
});

/**
 * @description 取得會員資料 (密碼登入) (Action)
 * @param checkCaptchaArgs 驗證圖形驗證碼，請求所需的參數
 * @param authMemberArgs 驗證會員帳號密碼，請求所需的參數
 */
export const loginByPassPhraseLoginAction = (checkCaptchaArgs: Captcha, authMemberArgs: LoginInfo): LoginActions => ({
  type: MEMBER_LOGIN__BY_PASS_PHRASE_LOGIN,
  payload: { checkCaptchaArgs, authMemberArgs }
});

/**
 * @description 檢核是否需要變更密碼 (Action)
 * @param info 會員資料
 */
export const checkLastTimePasswordDateAction = (info: MbGetinfoResp) => ({
  type: MEMBER_LOGIN__CHECK_LAST_TIME_PASSWORD_DATE,
  payload: { info }
});

/**
 * @description 緩存手機驗證登入 (Step-1) 表單資料
 * @param data 表單資料
 */
export const saveMobileLoginDataAction = (data: MbSigninReq): LoginActions => ({
  type: MEMBER_LOGIN__SAVE_MOBILE_LOGIN_DATA,
  payload: { data }
});

/**
 * @description 發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendOTPDoneAction = (response: MbSigninResp): LoginActions => ({
  type: MEMBER_LOGIN__SEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 重新發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const resendOTPAction = (checkCaptchaArgs: Captcha, data: LoginInfo): LoginActions => ({
  type: MEMBER_LOGIN__RESEND_OTP,
  payload: { checkCaptchaArgs, data }
});

/**
 * @description 重新發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const resendOTPDoneAction = (response: MbSigninResp): LoginActions => ({
  type: MEMBER_LOGIN__RESEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 使用 OTP 驗證碼登入 (驗證 OTP 驗證碼) (Action)
 * @param args 請求所需的參數
 */
export const loginByOTPAction = (args: AaOtpVerifyReq): LoginActions => ({
  type: MEMBER_LOGIN__LOGIN_BY_OTP,
  payload: { args }
});

/**
 * @description 設置 Redirect URL (登入完成後依路線轉導) (Action)
 * @param route 路由路線
 * @param state 透過路由傳遞的 State
 */
export const setLoginRedirectURLAction = (route: ROUTES, state?: any): LoginActions => ({
  type: MEMBER_LOGIN__SET_LOGIN_REDIRECT_URL,
  payload: { route, state }
});

/**
 * @description 重置登入流程資料緩存 (Action)
 */
export const resetLoginCacheAction = (): LoginActions => ({
  type: MEMBER_LOGIN__RESET_LOGIN_CACHE
});

/**
 * @description 發送會員登出 (Action)
 * @param args 請求所需的參數
 */
export const sendLogoutAction = (args: MbSignoutReq): LoginActions => ({
  type: MEMBER_LOGIN__SEND_LOGOUT,
  payload: { args }
});
